import { render, staticRenderFns } from "./roleApplyCheck.vue?vue&type=template&id=20b57860&scoped=true"
import script from "./roleApplyCheck.vue?vue&type=script&lang=js"
export * from "./roleApplyCheck.vue?vue&type=script&lang=js"
import style0 from "./roleApplyCheck.vue?vue&type=style&index=0&id=20b57860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b57860",
  null
  
)

export default component.exports